<script>
    import { each } from "svelte/internal";

    var platforms = {
        'appb' : {
            'name' : 'Colmo POS (Android)',
            'icon' : 'icon-b.png'
        },
        'linux' : {
            'name' : "Colmo POS (Linux)",
            'icon' : 'linux.png'
        },
        'pay' : {
            'name' : "ColmoPay",
            'icon' : 'colmopay-icon.png'
        },
        'qds' : {
            'name' : 'Queue Display System',
            'icon' : 'logo.png'
        },
        'dash' : {
            'name' : 'Dashboard',
            'icon' : 'icon-dash.png'
        }
        
    }
    //Retrieve all files
function xmlToJson(xml) {
 var parser;
  if (typeof xml === 'string') {
    parser = new DOMParser();
    xml = parser.parseFromString(xml, 'text/xml');
  }

  // Create the return object
  var obj = {};

  if (xml.nodeType == 1) {
    // element
    // do attributes
    if (xml.attributes.length > 0) {
      obj['@attributes'] = {};
      for (var j = 0; j < xml.attributes.length; j++) {
        var attribute = xml.attributes.item(j);
        obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
      }
    }
  } else if (xml.nodeType == 3) {
    // text
    obj = xml.nodeValue;
  }

  // do children
  // If just one text node inside
  if (xml.hasChildNodes() && xml.childNodes.length === 1 && xml.childNodes[0].nodeType === 3) {
    obj = xml.childNodes[0].nodeValue;
  } else if (xml.hasChildNodes()) {
    for (var i = 0; i < xml.childNodes.length; i++) {
      var item = xml.childNodes.item(i);
      var nodeName = item.nodeName;
      // camelCase
      nodeName = nodeName.charAt(0).toLowerCase() + nodeName.slice(1);
      if (typeof obj[nodeName] == 'undefined') {
        obj[nodeName] = xmlToJson(item);
      } else {
        if (typeof obj[nodeName].push == 'undefined') {
          var old = obj[nodeName];
          obj[nodeName] = [];
          obj[nodeName].push(old);
        }
        obj[nodeName].push(xmlToJson(item));
      }
    }
  }
  return obj;
}

function getIndexUrl(bucket, region, prefix) {
  return 'https://s3.' + region + '.amazonaws.com/' + bucket + '/?prefix=' + prefix;
}

function getIndexJson(xml) {
  var json = xmlToJson(xml);
  var list = [];
  if (json.listBucketResult.commonPrefixes)
    list = list.concat(json.listBucketResult.commonPrefixes);
  if (json.listBucketResult.contents)
    list = list.concat(json.listBucketResult.contents);

  return list;
}
var eachPlatform = {};
var showPrevious;
const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
async function getDirectory(){
   var list = await fetch(getIndexUrl('colmo','ap-southeast-1', 'apks')).then(r=>r.text()).then(getIndexJson);
   var allPlatforms = Object.keys(platforms);
   list.forEach((obj)=>{
    var key = obj.key.replace("apks/","");
    var match = allPlatforms.find(prefix=>key.startsWith(prefix));
    if(match){
        eachPlatform[match] = [...(eachPlatform[match] || []), {'file' : key.replace(`${match}-`,''), 'date' : new Date(obj.lastModified).toLocaleDateString()}];
    }
   });
   //Sort files
   allPlatforms.forEach(plat => {
    eachPlatform[plat] = eachPlatform[plat].sort((a, b) => b['file'].localeCompare(a['file'], undefined, {numeric: true, sensitivity: 'base'}));
   });
   console.log(eachPlatform);
}
async function getChangelogs(){
    changelogs = await fetch("https://cdn.colmo.my/apks/changelogs.json?uid="+Date().toString()).then(r=>r.json());
}
var changelogs = {};

getChangelogs();
getDirectory();
</script>
<div class="p-4 shadow text-center text-lg">
    App Store
</div>
<div class="lg:w-1/2 mx-auto p-4">
{#each Object.keys(platforms) as key}
{#if eachPlatform[key] && eachPlatform[key].length>0}
    <div class="rounded-2xl p-6 shadow-xl lg:flex">
        <div class="rounded-2xl w-20 h-20 mb-4 bg-gray-200 border border-gray-300">
            <img src="/assets/img/{platforms[key]['icon']}" class="object-contain" />
        </div>
        <div class="mx-4 flex-1">
            <p class="font-semibold text-lg">{platforms[key]['name']} <span class="text-xs bg-blue-500 font-semibold rounded-xl p-1 text-white">Blue</span></p>
            <p class="text-sm text-gray-600">Build {eachPlatform[key][0]['file'].split(".")[0]}</p>
            <p class="text-xs font-semibold">Last Updated On {eachPlatform[key][0]['date']}</p>
            {#if changelogs[key] && changelogs[key][parseInt(eachPlatform[key][0]['file'].split(".")[0])]}
                <div class="my-2">
                    {@html changelogs[key][parseInt(eachPlatform[key][0]['file'].split(".")[0])].replace(/(?:\r\n|\r|\n)/g, '<br>')}
                </div>
            {/if}
            <button class="text-gray-500 text-sm my-4" on:click={()=>showPrevious = showPrevious==key ? null : key}>All Versions ▾</button>
            {#if showPrevious==key}
            <div class="grid grid-cols-3">
                {#each eachPlatform[key] as file}
                
                <div class="col-span-2">
                    <span class="text-xs text-gray-500 pr-2">
                        {file['date']}
                    </span>
                    <span class="font-semibold">
                        Build {file['file'].split(".")[0]}
                    </span>
                </div>
                
                <div class="mb-4 text-right">
                    <a href="https://cdn.colmo.my/apks/{key}-{file['file']}" class="rounded-xl p-2 text-xs text-yellow-500 border border-yellow-500 text-center ">Use this</a>
                </div>
                {/each}
            </div>
            {/if}
        </div>
        {#if showPrevious!=key}
        <div class="self-center mt-6">
            <a href="https://cdn.colmo.my/apks/{key}-{eachPlatform[key][0]['file']}" class="rounded-xl p-4 text-white bg-yellow-500 shadow-md">Download</a>
        </div>
        {/if}
    </div>
{/if}
{/each}
</div>
<div class="m-4 text-sm text-gray-500">Copyrights Reserved {(new Date()).getFullYear()} Colmo Tech.<br />All binaries provided on this site should not be redistributed without permission, and should only be used with a Colmo License only.</div>